import { InformationTooltip } from '@/src/components/InformationTooltip'
import { appColors } from '@/src/theme'
import { Text } from '@chakra-ui/react'
import { FlexCol, FlexRow } from '@components'
import { isNullOrUndefined, numberFormat } from '@shared/utils'
import { formatMeasurement } from '@utils/formatMeasurement'

interface KPIBoxInfoProps {
  infoText: string
  kpiValue?: number
  percentageValue?: number
  tooltipText?: string
  hidePercentage?: boolean
}

const KPIBoxInfo = ({ infoText, kpiValue, percentageValue, tooltipText, hidePercentage }: KPIBoxInfoProps) => {
  const determineDecimalPlaces = (value: number) => {
    const absoluteValue = Math.abs(value)
    if (absoluteValue < 0.01) {
      return 3
    } else if (absoluteValue < 0.1) {
      return 2
    } else if (Number.isInteger(absoluteValue)) {
      return 0
    } else {
      return 1
    }
  }

  const roundWithDecimalIfNecessary = (value: number) => {
    if (value < 0) return numberFormat(Number(value.toFixed(determineDecimalPlaces(value))), 3)
    return numberFormat(Math.round(value))
  }

  return (
    <FlexRow
      maxWidth={'fit-content'}
      borderWidth={'1px'}
      borderColor={appColors.gray[100]}
      borderTopRadius={'8px'}
      bg='white'
      padding={'8px'}
      borderBottomRadius={'8px'}
      alignItems={'center'}
      borderRadius='8px'
    >
      <FlexCol gap={'2px'}>
        <Text
          whiteSpace='nowrap'
          fontSize='14px'
          color={appColors.gray[800]}
          fontWeight={400}
          fontFamily='Parabole'
          lineHeight={'20px'}
          display={'inline-flex'}
          gap={2}
          alignItems={'center'}
        >
          {infoText}
          {tooltipText && <InformationTooltip label={tooltipText} />}
        </Text>
        <FlexRow gap={'8px'} alignItems={'center'}>
          <Text
            whiteSpace='nowrap'
            fontSize='20px'
            color={appColors.gray[900]}
            fontWeight={600}
            fontFamily='Parabole'
            lineHeight={'20px'}
            marginTop={'4px'}
          >
            {isNullOrUndefined(kpiValue) ? '-' : formatMeasurement(kpiValue, 'kWh')}
          </Text>
          {!hidePercentage ? (
            <Text
              whiteSpace='nowrap'
              fontSize='20px'
              color={appColors.mutedForeground}
              fontWeight={116}
              fontFamily='Parabole'
              lineHeight={kpiValue && kpiValue !== 0 ? '14px' : '20px'}
              marginTop={'4px'}
            >
              {isNullOrUndefined(percentageValue) ? '-' : `${roundWithDecimalIfNecessary(percentageValue)} %`}
            </Text>
          ) : null}
        </FlexRow>
      </FlexCol>
    </FlexRow>
  )
}

export default KPIBoxInfo
